import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

function RequireAuth({ children }) {
    const { isAuthenticated, loading } = useContext(AuthContext);
    let location = useLocation();
  
    if (loading) {
      return <div>Loading...</div>;  // Display a loading indicator while authentication state is being determined
    }

    if (!isAuthenticated) {
      // Redirect to sign-in only if not authenticated and not loading
      return <Navigate to="/signin" state={{ from: location }} replace />;
    }
  
    return children;  // Render children if authenticated
  }

export default RequireAuth;
